import React, { useEffect, useRef } from "react";
import { endPoints } from "../../config/end-points";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useHistory, useParams } from "react-router-dom";
import useHttp from "../../hooks/use-http";
import { personalizeAction } from "../../store/pesonalize-store";
import TagsInput from "../UI/TagsInput";
import { useState } from "react";
import { FaPencilAlt, FaVideo } from "react-icons/fa";
import ThumbnailModal from "../shared/modals/ThumbnailModal";
import CopyLinkModals from "../shared/modals/CopyLinkModals";
import SendForReview from "../shared/modals/SendForReview";
import SendEmailModal from "../shared/modals/SendEmailModal";
import EmbedCodeModal from "../shared/modals/EmbedCodeModal";
import VideoActions from "./tabs/VideoActions";
import PollData from "./tabs/PollData";
import Reports from "./tabs/Reports";
import VideoSettings from "./tabs/VideoSettings";
import { campaignAction } from "../../store/campaign-store";
import { authActions } from "../../store/auth";
import EditSalesPageModals from "../shared/modals/EditSalesPageModals";
import { cuteToast } from "../UI/cute";
import LANDINGPAGES_DATA from "../../config/landingpages";
import { landingPageAction } from "../../store/landingpage-store";
import { BiImageAdd } from "react-icons/bi";
import ReactTooltip from "react-tooltip";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import useVideoPlayer from "./tabs/useVideoPlayer";
import { FaPlay, FaPause } from "react-icons/fa";
import { FiRefreshCcw, FiEye } from "react-icons/fi";
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi";
import { ImReply } from "react-icons/im";
// import ImageUploadModal from '../shared/modals/ImageUploadModal'
import { BsArrowsFullscreen, BsPencilSquare } from "react-icons/bs";
import ReactPlayer from "react-player/youtube";
// import Comments from "./tabs/Comments";

const Pesonalize = () => {
  const { camp_id } = useParams();

  const { sendRequest: campTempRequest } = useHttp();
  const { sendRequest: updateDataRequest } = useHttp();
  const { sendRequest: getLandingPageRequest } = useHttp();
  const { sendRequest: gifCreationRequest } = useHttp();
  const dispatch = useDispatch();

  const [pageLoad, setPageLoad] = useState(false);

  const campaign_data = useSelector((state) => state.campaign.campaign_data);
  const [videoUrl, setVideoUrl] = useState(null);

  const [addTags, setAddTags] = useState([]);
  const [addDesc, setAddDesc] = useState("");
  const [descTags, setDescTags] = useState(false);
  const [editCampaign, setEditCampaign] = useState(false);
  const [campaign_name, setCampaign_name] = useState("");
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [showGifMenu, setShowGifMenu] = useState(false);
  const [showCopyDropDown, setShowCopyDropDown] = useState(false);
  const refDropdown = useRef();
  const personalize_pollData = useSelector(
    (state) => state.personalize.personalize_pollData
  );

  const reports = useSelector((state) => state.personalize.personalize_reports);
  // console.log(reports.email);
  //gif creation
  const [showGifSection, setShowGifSection] = useState(false);

  const [gifDuration, setGifDuration] = useState({
    length: 5,
    start: 0,
    end: 5,
    duration: 0,
  });

  const [gifPreview, setGifPreview] = useState(false);
  // const handleGif = (event) => {
  //   event.preventDefault();
  //   setShowGifSection(true)
  // };

  //trim video
  const [showTrim, setShowTrim] = useState(false);
  const [videoDuration, setVideoDuration] = useState({
    length: 0,
    start: 0,
    end: 0,
    duration: 0,
  });

  const [trimDuration, setTrimDuration] = useState({
    length: 0,
    start: 0,
    end: 0,
    duration: 0,
  });

  const [showLoader, setShowLoader] = useState(false);

  //YT Player
  const [ytTrimPlayer, setYtTrimPlayer] = useState({
    url: "",
    playing: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
  });

  const ytTrimPlayerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setShowActionPopup(false);
        setShowCopyDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.addEventListener("mousedown", handleClickOutside);
    };
  }, [showActionPopup]);

  const landingPageId = useSelector(
    (state) => state.landingpage.landing_page_id
  );

  const history = useHistory();

  useEffect(() => {
    document.title = `${endPoints.title} | Personalize`;
  });

  /*
    Rebuild or re-init React-tooltip 
  */
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  useEffect(() => {
    // console.log(camp_id,'2nd',pageLoad)
    if (!pageLoad) {
      dispatch(authActions.setLoaderStatus({ status: true }));

      campTempRequest(
        {
          url: endPoints.fetchCampaign + "/" + camp_id,
          method: "GET",
        },
        responseHandle
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campTempRequest, camp_id]);

  useEffect(() => {
    getLandingPageRequest(
      {
        url: endPoints.fetchLandingPage + "/" + camp_id,
        method: "GET",
      },
      (response) => {
        if (response.status === 200) {
          // console.log(response)
          dispatch(
            landingPageAction.setPageId({ id: response.body.landing_page_id })
          );
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseHandle = async (response) => {
    console.log("Calling rest APi get campaigns Data");
    if (response.body) {
      dispatch(campaignAction.resetState());

      dispatch(
        campaignAction.preState({
          camp_id: camp_id,
        })
      );

      dispatch(
        personalizeAction.setPersonalizepageLoad({
          personalize_page_load: true,
        })
      );

      const campaign = response.body;

      if (campaign) {
        console.log("Calling Inside");
        dispatch(
          campaignAction.setCampaignData({
            campaign_data: campaign,
          })
        );

        if (campaign.trim_data) {
          const trim_data = JSON.parse(campaign.trim_data);
          setVideoUrl(
            `${campaign.video_path}#t=${trim_data.start},${trim_data.end}`
          );
          dispatch(
            campaignAction.setVideoDuration({
              total_duration: trim_data.length,
            })
          );

          setVideoDuration({
            ...videoDuration,
            length: trim_data.length,
            start: trim_data.start,
            end: trim_data.end,
            duration: trim_data.duration,
          });

          handleVideoLength({
            length: trim_data.length,
            start: trim_data.start,
            end: trim_data.end,
            status: "initial",
          });

          setTrimDuration({
            ...trimDuration,
            length: trim_data.length,
            start: trim_data.start,
            end: trim_data.end,
            duration: trim_data.duration,
          });

          handleTrimVideoLength({
            length: trim_data.length,
            start: trim_data.start,
            end: trim_data.end,
          });

          setGifDuration({
            ...gifDuration,
            duration: trim_data.duration,
          });
        } else {
          var myVideoPlayer = document.getElementById("video_player");
          setVideoUrl(campaign.video_path);
          // console.log(campaign)
          if (campaign.video_type === "embed") {
            console.log("inn.");
          } else {
            await Promise.resolve(
              myVideoPlayer.addEventListener("loadedmetadata", function () {
                // console.log(myVideoPlayer.duration);
                var duration = parseInt(myVideoPlayer.duration);

                dispatch(
                  campaignAction.setVideoDuration({
                    total_duration: duration,
                  })
                );

                setVideoDuration({
                  ...videoDuration,
                  length: duration,
                  start: 0,
                  end: duration,
                  duration,
                });

                setGifDuration({
                  ...gifDuration,
                  duration,
                });

                return true;
              })
            );
          }
        }

        // console.log(campaign.name);
        setCampaign_name(campaign.name);
        campaign.keywords && setAddTags(campaign.keywords.split(","));
        setAddDesc(campaign.description);
      }

      setPageLoad(true);
    }

    dispatch(authActions.setLoaderStatus({ status: false }));
  };

  const handleBlur = (event) => {
    event.preventDefault();
    if (descTags) {
      let updatedObj = {
        description: addDesc,
        id: camp_id,
      };
      setDescTags(false);
      updateDataRequest(
        {
          url: endPoints.updateCampaign,
          method: "POST",
          body: updatedObj,
        },
        (response) => {
          if (response.status === 200) {
            cuteToast({
              type: "success",
              message: "Saved Successfully.",
              timer: 5000,
              title: "Description",
            });
          }
        }
      );
    }
  };

  const handleTags = (event) => {
    event.preventDefault();
    if (descTags) {
      let updatedObj = {
        keywords: addTags.toString(),
        id: camp_id,
      };
      setDescTags(false);
      updateDataRequest(
        {
          url: endPoints.updateCampaign,
          method: "POST",
          body: updatedObj,
        },
        (response) => {
          if (response.status === 200) {
            cuteToast({
              type: "success",
              message: "Saved Successfully.",
              timer: 5000,
              title: "Tags",
            });
          }
        }
      );
    }
  };

  const handleClick = (event, action) => {
    event.preventDefault();
    action && action === "goback" && history.push("/");
  };

  //copy Link Code

  const anchorLink = `https://www.vidconnect.net/page/${camp_id}`;

  // This is the actual copy function.
  const copyFormatted = (html) => {
    // Create an iframe (isolated container) for the HTML
    var container = document.createElement("div");
    container.innerHTML = html;

    // Hide element
    container.style.position = "fixed";
    container.style.pointerEvents = "none";
    container.style.opacity = 0;

    // Detect all style sheets of the page
    var activeSheets = Array.prototype.slice
      .call(document.styleSheets)
      .filter(function (sheet) {
        return !sheet.disabled;
      });

    // Mount the iframe to the DOM to make `contentWindow` available
    document.body.appendChild(container);

    // Copy to clipboard
    window.getSelection().removeAllRanges();

    var range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);

    document.execCommand("copy");
    for (var i = 0; i < activeSheets.length; i++)
      activeSheets[i].disabled = true;
    document.execCommand("copy");
    for (var j = 0; j < activeSheets.length; j++)
      activeSheets[j].disabled = false;

    // Remove the iframe
    document.body.removeChild(container);
  };

  const handleCopy = (e, type) => {
    let message,
      copyText = "";
    if (type === "link") {
      /* Get the text field */
      copyText = anchorLink;
      /* Copy the text inside the text field */
      navigator.clipboard.writeText(copyText);
      message = "Your video URL is copied to clipboard.you can share now.";
      setShowCopyDropDown(false);
    } else {
      /* Get the text field */
      copyText = `<div style="margin: 0 auto;width: 100%; max-width: 360px; max-height: 260px;"> <div> <a href='${anchorLink}?' target="_blank" rel="noreferrer"> <img src='${campaign_data.gif_url}' style="max-width : 360px; max-height: 202px ;" alt="${anchorLink}?"/> </a> </div><div style="width: 100%; height: 50px;" > <div style="padding-left: 10px; padding-top: 5px; font-size: 18px; font-weight: bold; letter-spacing: 0.3px; font-family: Open Sans; height: 23px;"> <a href='${anchorLink}?' target="_blank" rel="noreferrer" style="color: #a852be; text-decoration: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;" >Watch Video</a> </div></div></div>`;

      copyFormatted(copyText);

      message =
        "Your video URL with thumbnail is copied to clipboard.you can share now.";
      setShowCopyDropDown(false);
    }

    cuteToast({
      type: "success",
      message: message,
      timer: 3000,
      title: "Video URL",
    });
  };

  //trim video functionality
  const videoElement = useRef();

  const {
    playerState,
    trimplayerState,
    gifplayerState,
    togglePlay,
    toggleTrimPlay,
    toggleGifPlay,
    handleOnTimeUpdate,
    handleTrimOnTimeUpdate,
    handleVideoProgress,
    handleTrimVideoProgress,
    // handleVideoSpeed,
    toggleMute,
    handleAudioLevel,
    handleVideoLength,
    handleTrimVideoLength,
    handleEndVideo,
    handleShowTrimSection,
    handleShowGifSection,
    handleGifOnTimeUpdate,
    handleGifVideoLength,
    handleGifVideoProgress,
  } = useVideoPlayer(videoElement);

  const [playerStatus, setPlayerStatus] = useState("initial");

  const handleTrimVideo = (value) => {
    // console.log(value);
    let start = value[0];
    let end = value[1];
    let videoLength = Math.floor(
      ((end - start) / 100) * videoDuration.duration
    );
    let startDuration = Math.floor((start / 100) * videoDuration.duration);
    let endDuration = Math.floor((end / 100) * videoDuration.duration);

    setTrimDuration({
      ...trimDuration,
      length: videoLength,
      start: startDuration,
      end: endDuration,
    });

    if (campaign_data.video_type === "embed") {
      setYtTrimPlayer({
        ...ytTrimPlayer,
        duration: videoLength,
      });
    } else {
      handleTrimVideoLength({
        length: videoLength,
        start: startDuration,
        end: endDuration,
      });
    }
  };

  const handleDesc = (e) => {
    // console.log(e)
    setAddDesc(e.target.value);
    setDescTags(true);
  };

  const handleShowTrim = (flag) => {
    if (flag === "show") {
      setShowTrim(true);
      setShowActionPopup(false);
      handleShowTrimSection(true);
      if (!campaign_data.trim_data) {
        setTrimDuration({
          ...trimDuration,
          length: videoDuration.duration,
          start: 0,
          end: videoDuration.duration,
          duration: videoDuration.duration,
        });

        handleTrimVideoLength({
          length: videoDuration.duration,
          start: 0,
          end: videoDuration.duration,
        });

        setYtTrimPlayer({
          ...ytTrimPlayer,
          duration: videoDuration.duration,
        });
      }
    } else {
      setTrimDuration(videoDuration);
      handleTrimVideoLength({
        length: videoDuration.length,
        start: videoDuration.start,
        end: videoDuration.end,
      });
      setYtTrimPlayer({
        ...ytTrimPlayer,
        duration: videoDuration.length,
      });
      setShowTrim(false);
      handleShowTrimSection(false);
    }
  };

  const handleTrimVideoData = (e) => {
    updateDataRequest(
      {
        url: endPoints.updateCampaign,
        method: "POST",
        body: { trim_data: JSON.stringify(trimDuration), id: camp_id },
      },
      (response) => {
        if (response.status === 200) {
          setVideoDuration(trimDuration);
          dispatch(
            campaignAction.setVideoDuration({
              total_duration: trimDuration.length,
            })
          );
          handleVideoLength({
            length: trimDuration.length,
            start: trimDuration.start,
            end: trimDuration.end,
            status: "trimEvent",
          });
          setShowTrim(false);
          handleShowTrimSection(false);
          setVideoUrl(
            `${videoUrl}#t=${videoDuration.start},${videoDuration.end}`
          );
          setPlayerStatus("trimEvent");
          // videoElement.current.currentTime = videoDuration.start
        }
      }
    );
  };

  const toggleFullScreen = () => {
    var el = document.getElementById("video_player");
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  };

  const onCanPlay = (e) => {
    // console.log('can play'+e)
    setShowLoader(false);
  };

  const onloadstart = () => {
    // console.log("start")
    setShowLoader(true);
  };
  //gif functionality

  const handleShowGif = (flag) => {
    if (flag === "show") {
      setShowActionPopup(false);
      setShowGifMenu(false);
      setShowGifSection(true);
      handleShowGifSection(true);
    } else {
      // setTrimDuration(videoDuration)
      // handleTrimVideoLength({
      //   length:videoDuration.length,
      //   start:videoDuration.start,
      //   end:videoDuration.end
      // })
      setShowGifMenu(false);
      setShowGifSection(false);
      handleShowGifSection(false);
    }
  };

  const handleGifVideoData = () => {
    dispatch(
      authActions.setLoaderStatus({
        status: true,
        loader_text: "Creating GIF will take some time.Please wait...",
      })
    );
    gifCreationRequest(
      {
        url: endPoints.gifCreation,
        method: "POST",
        body: { gif_data: JSON.stringify(gifDuration), id: camp_id,gif_url:campaign_data.gif_url},
      },
      (response) => {
        if (response.status === 200) {
          // console.log(response);
          dispatch(
            authActions.setLoaderStatus({ status: false, loader_text: "" })
          );
          dispatch(
            campaignAction.setCampaignData({
            campaign_data: {...campaign_data,gif_url:response.gif},
            })
          );
          cuteToast({
            type: "success",
            message: "You can use this GIF in Send Email and can be set as a Thumbnail",
            timer: 5000,
            title: "GIF Created Successfully",
          });
          setGifPreview(false);
          setShowGifSection(false);
        }
      }
    );
  };

  const handleGifVideo = (value) => {
    // console.log(value);
    let start = value[0];
    let end = value[1];
    let videoLength = Math.floor(
      ((end - start) / 100) * videoDuration.duration
    );
    let startDuration = Math.floor((start / 100) * videoDuration.duration);
    let endDuration = Math.floor((end / 100) * videoDuration.duration);

    setGifDuration({
      ...gifDuration,
      length: videoLength,
      start: startDuration,
      end: endDuration,
    });

    handleGifVideoLength({
      length: videoLength,
      start: startDuration,
      end: endDuration,
    });
  };

  //YT Player
  const handleDuration = (duration) => {
    // console.log(duration)
    dispatch(
      campaignAction.setVideoDuration({
        total_duration: duration,
      })
    );

    setVideoDuration({
      ...videoDuration,
      length: duration,
      start: 0,
      end: duration,
      duration,
    });
  };

  const handleSeekMouseDown = (e) => {
    // console.log(e,"handleSeekMouseDown")
    setYtTrimPlayer({
      ...ytTrimPlayer,
      seeking: true,
    });
  };

  const handleSeekChange = (e) => {
    // console.log(e,"handleSeekChange")
    setYtTrimPlayer({
      ...ytTrimPlayer,
      played: parseFloat(e.target.value),
    });
  };

  const handleSeekMouseUp = (e) => {
    // console.log(e,"handleSeekMouseUp")
    setYtTrimPlayer({
      ...ytTrimPlayer,
      seeking: false,
    });
    ytTrimPlayerRef.current.seekTo(parseFloat(e.target.value));
  };

  function format(seconds) {
    // console.log(seconds)
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = pad(date.getUTCSeconds());
    if (hh) {
      return `${hh}:${pad(mm)}:${ss}`;
    }
    return `${mm}:${ss}`;
  }

  function pad(string) {
    return ("0" + string).slice(-2);
  }

  const handleTrimProgress = (state) => {
    if (!ytTrimPlayer.seeking) {
      setYtTrimPlayer({
        ...ytTrimPlayer,
        loaded: state.loaded,
        played: state.played,
      });
    }
  };

  const handlePreviewGif = () => {};

  return (
    <>
      <main className="midwrap">
        <ReactTooltip />
        <div className="container" ref={refDropdown}>
          <div className="d-none d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-4">
            <h3 className="font25 m-0">
              <i
                onClick={(e) => handleClick(e, "goback")}
                className="fa fa-reply me-3"
                style={{ cursor: "pointer" }}
              ></i>
              {editCampaign && (
                <input
                  maxLength={100}
                  value={campaign_name}
                  onChange={(e) => setCampaign_name(e.target.value)}
                  onBlur={(e) => setEditCampaign(false)}
                  autoFocus={true}
                  className="border-0 px-2 custcampaignname"
                />
              )}
              {!editCampaign && (
                <>
                  <span className="me-2">{campaign_name}</span>

                  <FaPencilAlt
                    onClick={(e) => setEditCampaign(true)}
                    style={{ cursor: "pointer" }}
                  />
                </>
              )}
            </h3>
          </div>
          {!showTrim && (
            <section
              className={`edit_video_personalize_section w-100 ${
                showGifSection ? "d-none" : ""
              }`}
            >
              <div className="sec1">
                <div className="row">
                  <div className="col-xl-4 col-lg-6 col-md-12">
                    <div className="edit_video_ps_bx video-preview bg-white rounded">
                      <div className="video_bx2 position-relative video-container">
                        {campaign_data &&
                          (campaign_data.video_type === "cust_upload" ||
                            campaign_data.video_type === "upload") && (
                            <>
                              <div className="v_link">
                                <button
                                  onClick={(e) => setShowGifMenu(!showGifMenu)}
                                  className="border-0 bg-transparent"
                                  // onBlur={(e) => setShowActionPopup(!showActionPopup)}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/ic_2.png"
                                    }
                                    className="img-fluid"
                                    alt="img"
                                  />
                                </button>
                                <div
                                  className={`collapse ${
                                    showGifMenu && "show"
                                  }`}
                                  id="v_link_dropdown"
                                  // ref={ref}
                                >
                                  <ul className="m-0 p-0 list-unstyled">
                                    {/* <li>
                                                                      <a href="#0">
                                                                          <i><img src={process.env.PUBLIC_URL + "/assets/images/clone.png"} alt="img" /></i> Clone</a>
                                                                  </li> */}
                                    <li>
                                      <button
                                        onClick={(e) => handleShowGif("show")}
                                      >
                                        <i>
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assets/images/create_gif.png"
                                            }
                                            alt="img"
                                          />
                                        </i>{" "}
                                        Create GIF
                                      </button>
                                    </li>
                                    <li>
                                      <a
                                        href={campaign_data.video_path}
                                        download
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <i>
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/assets/images/download.png"
                                            }
                                            alt="img"
                                          />
                                        </i>{" "}
                                        Download
                                      </a>
                                    </li>
                                    {/* <li>
                                                                      <a href="#0"><i><img src={process.env.PUBLIC_URL + "/assets/images/delete.png"} alt="img" /></i> Delete</a>
                                                                  </li> */}
                                  </ul>
                                </div>
                              </div>

                              <video
                                src={videoUrl}
                                className="w-100"
                                // controls={true}
                                poster={campaign_data.default_poster}
                                height="240px"
                                id="video_player"
                                onTimeUpdate={handleOnTimeUpdate}
                                onEnded={handleEndVideo}
                                // loop={true}
                                ref={videoElement}
                              ></video>
                              <div className="player-controls-container player-controls-outside showing-controls">
                                <button
                                  className="border-0 bg-transparent play-pause-button"
                                  id="pauseAndPlayBtn"
                                  onClick={togglePlay}
                                >
                                  {!playerState.isPlaying ? (
                                    <FaPlay className="text-white" />
                                  ) : (
                                    <FaPause className="text-white" />
                                  )}
                                </button>

                                <div className="player-progress">
                                  <Slider
                                    // range
                                    // allowCross={true}
                                    value={playerState.progress}
                                    onChange={handleVideoProgress}
                                  />
                                </div>
                                <span className="player-currenttime">
                                  {" "}
                                  {Math.floor(
                                    Math.abs(playerState.currentTime) / 60
                                  ) +
                                    ":" +
                                    (
                                      "0" +
                                      Math.floor(
                                        Math.abs(playerState.currentTime) % 60
                                      )
                                    ).slice(-2)}
                                  /{" "}
                                  {Math.floor(videoDuration.length / 60) +
                                    ":" +
                                    (
                                      "0" +
                                      Math.floor(videoDuration.length % 60)
                                    ).slice(-2)}
                                </span>
                                <div className="actions-container pull-right">
                                  <span
                                    className="player-audio controls-btn me-3"
                                    id="videoVolumeBtn"
                                  >
                                    {!playerState.isMuted ? (
                                      <HiVolumeUp
                                        className="text-white player-volume"
                                        onClick={toggleMute}
                                        size={16}
                                      />
                                    ) : (
                                      <HiVolumeOff
                                        className="text-white player-volume"
                                        onClick={toggleMute}
                                        size={16}
                                      />
                                    )}
                                    <div className="volume-container d-none">
                                      <Slider
                                        vertical
                                        min={0}
                                        onChange={handleAudioLevel}
                                        defaultValue={
                                          playerState.isMuted ? 0 : 50
                                        }
                                        value={
                                          playerState.isMuted
                                            ? 0
                                            : playerState.volume
                                        }
                                      />
                                    </div>
                                  </span>
                                  <span className="player-fullscreen controls-btn">
                                    <BsArrowsFullscreen
                                      className="text-white player-fullscreen-btn"
                                      size={16}
                                      onClick={toggleFullScreen}
                                    />
                                  </span>
                                </div>
                              </div>
                            </>
                          )}
                        {campaign_data &&
                          campaign_data.video_type === "embed" && (
                            <ReactPlayer
                              url={campaign_data.video_path}
                              className="w-100"
                              height="240px"
                              id="video_player"
                              onDuration={handleDuration}
                            />
                          )}
                      </div>

                      <div className="ps-4 pe-4 pt-4 pb-4 d-flex justify-content-between">
                        {campaign_data &&
                          (campaign_data.video_type === "upload" ||
                            campaign_data.video_type === "cust_upload") && (
                            <div className="video_add ">
                              <a
                                // data-target="#thumnail"
                                className="border-0 bg-transparent"
                                data-bs-toggle="modal"
                                data-effect="solid"
                                data-tip="Add Thumbnail For Video"
                                onClick={(e) =>
                                  dispatch(
                                    personalizeAction.setPersonalizeThumbnailModal(
                                      { personalize_thumbnailmodal: true }
                                    )
                                  )
                                }
                                href="#thumnail"
                              >
                                {/* <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/ic_plus.png"
                                }
                                className="img_ic"
                                alt="img"
                              /> */}
                                <BiImageAdd
                                  size={30}
                                  className="text-main-color"
                                />
                              </a>
                              <ThumbnailModal />
                            </div>
                          )}

                        <div className="link2 dropdown">
                          <button
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            className="border-0 bg-transparent dropdown-toggle"
                            onClick={() => setShowActionPopup(!showActionPopup)}
                          >
                            <span>
                              <FaVideo size={24} className="text-main-color" />
                            </span>{" "}
                            Edit & Personalize{" "}
                            <i className="fa fa-angle-down"></i>
                          </button>
                          {showActionPopup && (
                            <div
                              className={`dropdown-menu w-100 show`}
                              aria-labelledby="dropdownMenuButton"
                              // ref={refDropdown}
                            >
                              <a
                                className="dropdown-item"
                                href="#myModal4"
                                data-bs-toggle="modal"
                                onClick={() =>
                                  setShowActionPopup(!showActionPopup)
                                }
                              >
                                Personalize Video
                              </a>
                              {campaign_data.video_type === "cust_upload" && (
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => handleShowTrim("show")}
                                >
                                  Edit Video
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-6 col-md-12">
                    <div className="mb-3">
                      <label className="font2 d-block pb-1">Description</label>
                      <textarea
                        name="description"
                        className="form-control border-0 shadow-none height146"
                        placeholder="Enter a nice description..."
                        defaultValue={addDesc}
                        onChange={handleDesc}
                        onBlur={(e) => handleBlur(e, "description")}
                      />
                    </div>
                    <div className="mb-3 custom_tag">
                      <label className="font2 pb-1 tags_h">Tags</label>
                      {/* <input name="" type="text" className="form-control border-0 shadow-none"/> */}
                      <TagsInput
                        selectedTags={addTags}
                        setAddTags={setAddTags}
                        handleTags={handleTags}
                        setDescTags={setDescTags}
                      />
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-12 col-md-12 pt-2">
                    <div className="last_viewed bg-white p-2 pt-2 pb-2 rounded mb-3 mt-4">
                      <div className="row p-2">
                        <div className="col-md-3 order-md-2 text-end offset-md-1">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/last_viewed.png"
                            }
                            className="img-fluid"
                            alt="img"
                          />
                        </div>

                        <div className="col-md-8 order-md-1">
                          <div className="lv_detail">
                            <p className="lv_txt m-0">
                              Last viewed{" "}
                              <i
                                className="fa fa-question-circle"
                                data-tip="Last person viewed details are shown here."
                                data-effect="solid"
                              ></i>
                            </p>
                            {reports.email ? (
                              <>
                                <p className="lv_email m-0">{reports.email}</p>
                                <small>2022-01-18 T 01:04:22Z</small>
                              </>
                            ) : (
                              <p className="lv_email m-0">No views yet</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="sales_page_video bg-white rounded mb-3">
                      <h5 className="m-0">Sales pages for this video</h5>
                      <div className="ps-3 pe-3 pt-3 pb-3 d-flex justify-content-between">
                        <div className="cl_sl_a d-flex align-items-center flex-wrap">
                          {landingPageId &&
                            LANDINGPAGES_DATA.map(
                              (elem) =>
                                elem.id === landingPageId && (
                                  <figure className="m-0 me-2" key={elem.id}>
                                    <img
                                      src={elem.thumbnail}
                                      className="rounded d-flex thumbnail"
                                      alt="img"
                                    />
                                  </figure>
                                )
                            )}

                          <figcaption>
                            <h6 className="m-0">Sales Page</h6>
                            {/* <a href="#0" className="text-decoration-none link3"><i className="fa fa-trash"></i> Remove</a> */}
                          </figcaption>
                        </div>
                        <div className="cl_sl_b">
                          <a
                            href={`https://www.vidconnect.net/page/${camp_id}`}
                            target="_blank"
                            rel="noreferrer"
                            data-effect="solid"
                            data-tip="Sales Page Preview"
                          >
                            {" "}
                            <FiEye />
                          </a>
                          <a
                            href="#editsalespage"
                            data-bs-toggle="modal"
                            data-effect="solid"
                            data-tip="Click to change sales page"
                          >
                            {" "}
                            <FiRefreshCcw />
                          </a>
                          {/* <Link
                            to={`/${camp_id}/edit-landing`}
                            data-effect="solid"
                            data-tip="Click to edit sales page"
                          >
                            {" "}
                            <BsPencilSquare />
                          </Link> */}

                          <Link
                            to={{
                              pathname: "/" + camp_id + "/edit-landing",
                              state: { fromPersonalize: true },
                            }}
                            data-effect="solid"
                            data-tip="Click to edit sales page"
                          >
                            {" "}
                            <BsPencilSquare />
                          </Link>
                        </div>
                        <EditSalesPageModals landingPageId={landingPageId} />
                      </div>
                    </div>
                  </div>

                  <hr className="col-md-8 offset-md-4" />
                  <div className="col-xl-8 col-md-12 offset-xl-4">
                    <div className="row r_ftr">
                      <div className="col-xl-4 col-md-6 col-lg-12 col-md-12">
                        <div className="dropdown">
                          <NavLink
                            data-bs-toggle="collapse"
                            to="#copyDropDown"
                            role="button"
                            aria-expanded="false"
                            aria-controls="copyDropDown"
                            onClick={(e) =>
                              setShowCopyDropDown(!showCopyDropDown)
                            }
                            className="btn btn1 ps-4 pe-4 shadow-none mb-4 w-100 dropdown-toggle"
                          >
                            Copy Link
                          </NavLink>
                          {showCopyDropDown && (
                            <div
                              className="dropdown-menu show copyDropDown"
                              aria-labelledby="dropdownCopyButton"
                              id="copyDropDown"
                            >
                              <button
                                className="dropdown-item"
                                onClick={(e) => handleCopy(e, "thumbnail")}
                              >
                                Copy Link With Thumbnail
                              </button>
                              <button
                                className="dropdown-item"
                                onClick={(e) => handleCopy(e, "link")}
                              >
                                Copy Link
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-3 col-md-6 col-lg-12 col-md-12">
                        <a
                          href="#myModal6"
                          data-bs-toggle="modal"
                          className="btn btn1 ps-4 pe-4 shadow-none mb-4 w-100"
                        >
                          Send Email
                        </a>
                      </div>
                      <div className="d-none col-xl-3 col-md-6 col-lg-12 col-md-12 send_review d-inline-block">
                        <a
                          href="#myModal5"
                          data-bs-toggle="modal"
                          className="btn bg-white shadow-none mb-4 w-100"
                        >
                          Send for review
                        </a>
                      </div>
                      <div className="col-xl-3 col-md-6 col-lg-12 col-md-12 d-inline-block">
                        <a
                          href="#myModal4"
                          data-bs-toggle="modal"
                          className="btn btn1 shadow-none w-100"
                          // data-tip="Embed Code"
                          // data-effect="solid"
                        >
                          {/* <i className="fa fa-code"></i> */}
                          Personalize
                        </a>
                      </div>
                    </div>

                    <CopyLinkModals />

                    <SendForReview />

                    <SendEmailModal />

                    <EmbedCodeModal />
                  </div>
                </div>
              </div>

              <div className="sec2 bg-white rounded mt-5 mb-4">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link bg-transparent active"
                      id="video-action-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#video-action"
                      type="button"
                      role="tab"
                      aria-controls="video-action"
                      aria-selected="false"
                    >
                      Video Action
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link bg-transparent"
                      id="video-settings-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#video-settings"
                      type="button"
                      role="tab"
                      aria-controls="video-settings"
                      aria-selected="false"
                    >
                      Video Settings
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link bg-transparent"
                      id="reports-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reports"
                      type="button"
                      role="tab"
                      aria-controls="reports"
                      aria-selected="true"
                    >
                      Reports
                    </button>
                  </li>
                  {personalize_pollData.option1 && (
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link bg-transparent"
                        id="pollAction-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#pollAction"
                        type="button"
                        role="tab"
                        aria-controls="pollAction"
                        aria-selected="true"
                      >
                        Poll Results
                      </button>
                    </li>
                  )}
                  {/* <li className="nav-item" role="presentation">
                                      <button className="nav-link bg-transparent" id="comments-tab" data-bs-toggle="tab" data-bs-target="#comments" type="button" role="tab" aria-controls="comments" aria-selected="false">Comments</button>
                                  </li> */}
                </ul>
                <div className="tab-content p-4 ps-5 pe-5" id="myTabContent">
                  <div
                    className="tab-pane fade"
                    id="reports"
                    role="tabpanel"
                    aria-labelledby="reports-tab"
                  >
                    <Reports />
                  </div>

                  <div
                    className="tab-pane fade"
                    id="pollAction"
                    role="tabpanel"
                    aria-labelledby="pollAction-tab"
                  >
                    {personalize_pollData && <PollData />}
                  </div>

                  <div
                    className="tab-pane fade  show active"
                    id="video-action"
                    role="tabpanel"
                    aria-labelledby="video-action-tab"
                  >
                    <VideoActions
                      useVideoPlayer={useVideoPlayer}
                      videoUrl={videoUrl}
                      videoDuration={videoDuration}
                      playerStatus={playerStatus}
                      // videoElement={videoElement}
                    />
                  </div>

                  <div
                    className="tab-pane fade"
                    id="video-settings"
                    role="tabpanel"
                    aria-labelledby="video-settings-tab"
                  >
                    <VideoSettings />
                  </div>

                  {/* <div className="tab-pane fade" id="comments" role="tabpanel" aria-labelledby="comments-tab">
                                      <Comments />
                                  </div> */}
                </div>
              </div>
            </section>
          )}

          {showTrim && (
            <section className="trim_video_section w-100 ">
              <div className="sec3">
                <div className="main-video-container">
                  <div className="video-container position-relative">
                    {campaign_data.video_type === "embed" && (
                      <ReactPlayer
                        // url={campaign_data.video_path}
                        url={`${campaign_data.video_path}&start=${trimDuration.start}&end=${trimDuration.end}`}
                        height="390px"
                        id="video_player"
                        playing={ytTrimPlayer.playing}
                        onPlay={() =>
                          setYtTrimPlayer({ ...ytTrimPlayer, playing: true })
                        }
                        onPause={() =>
                          setYtTrimPlayer({ ...ytTrimPlayer, playing: false })
                        }
                        onProgress={handleTrimProgress}
                        onReady={() => setShowLoader(false)}
                        // onBuffer={()=>setShowLoader(true)}
                        onDuration={handleDuration}
                        muted={ytTrimPlayer.muted}
                        volume={ytTrimPlayer.volume}
                        ref={ytTrimPlayerRef}
                      />
                    )}
                    {campaign_data.video_type === "cust_upload" && (
                      <video
                        height="390px"
                        preload="metadata"
                        src={`${campaign_data.video_path}#t=${trimDuration.start},${trimDuration.end}`}
                        ref={videoElement}
                        onTimeUpdate={handleTrimOnTimeUpdate}
                        onLoadStart={onloadstart}
                        onCanPlay={onCanPlay}
                        poster={campaign_data.poster}
                        muted={trimplayerState.isMuted}
                      />
                    )}
                    {showLoader && (
                      <div className="videoLoading loader-background">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/vidloading.gif`}
                          alt={"Loding.."}
                        />
                      </div>
                    )}
                    {campaign_data.video_type === "cust_upload" && (
                      <div className="player-controls-container player-controls-outside showing-controls">
                        <button
                          className="border-0 bg-transparent play-pause-button"
                          id="pauseAndPlayBtn"
                          onClick={toggleTrimPlay}
                        >
                          {!trimplayerState.isPlaying ? (
                            <FaPlay className="text-white" />
                          ) : (
                            <FaPause className="text-white" />
                          )}
                        </button>
                        <div className="components-marker-container"></div>
                        <div className="components-time-container">
                          <div className="se-clip-time hide">
                            <span className="se-selected-type"></span>
                            <div className="timer-pop-up hide">
                              <div className="timer-start-section">
                                <div className="timer-label">Start time</div>
                                <input
                                  type="text"
                                  className="timer-start-input"
                                />
                                <div className="timer-arrow-section">
                                  <div className="arrow up-arrow timer-input-btn timer-start-btn-plus"></div>
                                  <div className="arrow down-arrow timer-input-btn timer-start-btn-minus"></div>
                                </div>
                              </div>
                              <div className="timer-stop-section">
                                <div className="timer-label">Stop time</div>
                                <input
                                  type="text"
                                  className="timer-stop-input"
                                />
                                <div className="timer-arrow-section">
                                  <div className="arrow up-arrow timer-input-btn timer-stop-btn-plus"></div>
                                  <div className="arrow down-arrow timer-input-btn timer-stop-btn-minus"></div>
                                </div>
                              </div>
                              <div className="timer-div-arrow"></div>
                            </div>
                          </div>
                        </div>
                        <div className="notification-line"></div>

                        <div
                          id="chapterIndicatorId"
                          className="hp-indicator hide"
                        ></div>
                        <div className="player-progress">
                          <Slider
                            // range
                            // allowCross={true}
                            value={trimplayerState.progress}
                            onChange={handleTrimVideoProgress}
                          />
                        </div>
                        <span className="player-currenttime">
                          {" "}
                          {Math.floor(
                            Math.abs(trimplayerState.currentTime) / 60
                          ) +
                            ":" +
                            (
                              "0" +
                              Math.floor(
                                Math.abs(trimplayerState.currentTime) % 60
                              )
                            ).slice(-2)}
                          /{" "}
                          {Math.floor(trimDuration.length / 60) +
                            ":" +
                            ("0" + Math.floor(trimDuration.length % 60)).slice(
                              -2
                            )}
                        </span>
                        <div className="actions-container pull-right d-none">
                          <span
                            className="player-audio controls-btn"
                            id="videoVolumeBtn"
                          >
                            {!playerState.isMuted ? (
                              <HiVolumeUp
                                className="text-white player-volume"
                                onClick={toggleMute}
                              />
                            ) : (
                              <HiVolumeOff
                                className="text-white player-volume"
                                onClick={toggleMute}
                              />
                            )}
                            <div className="volume-container">
                              <Slider
                                vertical
                                min={0}
                                onChange={handleAudioLevel}
                                defaultValue={playerState.isMuted ? 0 : 50}
                                value={
                                  playerState.isMuted ? 0 : playerState.volume
                                }
                              />
                            </div>
                          </span>
                        </div>
                      </div>
                    )}

                    {campaign_data.video_type === "embed" && (
                      <div className="player-controls-container player-controls-outside showing-controls">
                        <button
                          className="border-0 bg-transparent play-pause-button"
                          id="pauseAndPlayBtn"
                          onClick={() =>
                            setYtTrimPlayer({
                              ...ytTrimPlayer,
                              playing: !ytTrimPlayer.playing,
                            })
                          }
                        >
                          {!ytTrimPlayer.playing ? (
                            <FaPlay className="text-white" />
                          ) : (
                            <FaPause className="text-white" />
                          )}
                        </button>

                        <div className="player-progress">
                          <input
                            type="range"
                            // allowCross={true}
                            min={0}
                            max={1}
                            value={ytTrimPlayer.played}
                            onMouseDown={handleSeekMouseDown}
                            onChange={handleSeekChange}
                            onMouseUp={handleSeekMouseUp}
                            step="any"
                            className="player-progress-input"
                          />
                        </div>
                        <span className="player-currenttime">
                          {" "}
                          {format(
                            ytTrimPlayer.duration * ytTrimPlayer.played
                          )}/ {format(ytTrimPlayer.duration)}
                        </span>
                      </div>
                    )}

                    <div className="trim-slider-container mt-2">
                      <Slider
                        range
                        allowCross={false}
                        defaultValue={[
                          Math.round(
                            (trimDuration.start / trimDuration.duration) * 100
                          ),
                          Math.round(
                            (trimDuration.end / trimDuration.duration) * 100
                          ),
                        ]}
                        // onChange={handleTrimVideo}
                        onAfterChange={handleTrimVideo}
                        trackStyle={[
                          {
                            backgroundColor: "#aa4ee4",
                            height: "25px",
                            marginTop: "-10px",
                          },
                          {
                            backgroundColor: "green",
                          },
                        ]}
                        // handleStyle={[{ backgroundColor: 'yellow' }, { backgroundColor: 'gray' }]}
                        railStyle={{
                          backgroundColor: "#372e58",
                          height: "25px",
                          padding: "10px 0px",
                          marginTop: "-10px",
                          borderRadius: 0,
                        }}
                      />
                    </div>
                    <div className="trim-before-container d-none">
                      <div className="trim-before-time-element">
                        <div className="arrow right-arrow"></div>
                        <span className="trim-before-time">
                          {trimDuration.start}
                        </span>
                      </div>
                    </div>
                    <div className="trim-after-container d-none">
                      <div className="trim-after-time-element">
                        <div className="arrow left-arrow"></div>
                        <span className="trim-after-time">
                          {trimDuration.end}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="action-container mt-4">
                    <button
                      className="btn bg-secondary py-2"
                      onClick={(e) => handleShowTrim("hide")}
                    >
                      Cancel Editing
                    </button>
                    <button className="btn py-2" onClick={handleTrimVideoData}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}

          {showGifSection && (
            <section className="trim_video_section w-100 ">
              <div className="sec3">
                <div className="main-video-container">
                  <div className="video-container position-relative">
                    <video
                      height="390px"
                      preload="metadata"
                      src={`${campaign_data.video_path}#t=${gifDuration.start},${gifDuration.end}`}
                      ref={videoElement}
                      onTimeUpdate={handleGifOnTimeUpdate}
                      onLoadStart={onloadstart}
                      onCanPlay={onCanPlay}
                      poster={campaign_data.poster}
                      muted={gifplayerState.isMuted}
                    />
                    {showLoader && (
                      <div className="videoLoading loader-background">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/vidloading.gif`}
                          alt={"Loding.."}
                        />
                      </div>
                    )}
                    <div className="player-controls-container player-controls-outside showing-controls">
                      <button
                        className="border-0 bg-transparent play-pause-button"
                        id="pauseAndPlayBtn"
                        onClick={toggleGifPlay}
                      >
                        {!gifplayerState.isPlaying ? (
                          <FaPlay className="text-white" />
                        ) : (
                          <FaPause className="text-white" />
                        )}
                      </button>
                      <div className="components-marker-container"></div>
                      <div className="components-time-container">
                        <div className="se-clip-time hide">
                          <span className="se-selected-type"></span>
                          <div className="timer-pop-up hide">
                            <div className="timer-start-section">
                              <div className="timer-label">Start time</div>
                              <input
                                type="text"
                                className="timer-start-input"
                              />
                              <div className="timer-arrow-section">
                                <div className="arrow up-arrow timer-input-btn timer-start-btn-plus"></div>
                                <div className="arrow down-arrow timer-input-btn timer-start-btn-minus"></div>
                              </div>
                            </div>
                            <div className="timer-stop-section">
                              <div className="timer-label">Stop time</div>
                              <input type="text" className="timer-stop-input" />
                              <div className="timer-arrow-section">
                                <div className="arrow up-arrow timer-input-btn timer-stop-btn-plus"></div>
                                <div className="arrow down-arrow timer-input-btn timer-stop-btn-minus"></div>
                              </div>
                            </div>
                            <div className="timer-div-arrow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="notification-line"></div>

                      <div
                        id="chapterIndicatorId"
                        className="hp-indicator hide"
                      ></div>
                      <div className="player-progress">
                        <Slider
                          // range
                          // allowCross={true}
                          value={gifplayerState.progress}
                          onChange={handleGifVideoProgress}
                        />
                      </div>
                      <span className="player-currenttime">
                        {" "}
                        {Math.floor(Math.abs(gifplayerState.currentTime) / 60) +
                          ":" +
                          (
                            "0" +
                            Math.floor(
                              Math.abs(gifplayerState.currentTime) % 60
                            )
                          ).slice(-2)}
                        /{" "}
                        {Math.floor(gifDuration.length / 60) +
                          ":" +
                          ("0" + Math.floor(gifDuration.length % 60)).slice(-2)}
                      </span>
                      <div className="actions-container pull-right d-none">
                        <span
                          className="player-audio controls-btn"
                          id="videoVolumeBtn"
                        >
                          {!gifplayerState.isMuted ? (
                            <HiVolumeUp
                              className="text-white player-volume"
                              onClick={toggleMute}
                            />
                          ) : (
                            <gifplayerState
                              className="text-white player-volume"
                              onClick={toggleMute}
                            />
                          )}
                          <div className="volume-container">
                            <Slider
                              vertical
                              min={0}
                              onChange={handleAudioLevel}
                              defaultValue={gifplayerState.isMuted ? 0 : 50}
                              value={
                                gifplayerState.isMuted
                                  ? 0
                                  : gifplayerState.volume
                              }
                            />
                          </div>
                        </span>
                      </div>
                    </div>

                    <div className="trim-slider-container mt-2">
                      <Slider
                        range
                        allowCross={false}
                        defaultValue={[
                          Math.round(
                            (gifDuration.start / gifDuration.duration) * 100 + 1
                          ),
                          Math.round(
                            (gifDuration.end / gifDuration.duration) * 100 + 1
                          ),
                        ]}
                        onAfterChange={handleGifVideo}
                        draggableTrack={true}
                        trackStyle={[
                          {
                            backgroundColor: "#aa4ee4",
                            height: "25px",
                            marginTop: "-10px",
                          },
                          {
                            backgroundColor: "green",
                          },
                        ]}
                        // handleStyle={[{ backgroundColor: 'yellow' }, { backgroundColor: 'gray' }]}
                        railStyle={{
                          backgroundColor: "#372e58",
                          height: "25px",
                          padding: "10px 0px",
                          marginTop: "-10px",
                          borderRadius: 0,
                        }}
                        data-tip="Length of Gif"
                        data-effect="solid"
                      />
                      <ReactTooltip />
                    </div>
                    <div className="trim-before-container d-none">
                      <div className="trim-before-time-element">
                        <div className="arrow right-arrow"></div>
                        <span className="trim-before-time">
                          {gifDuration.start}
                        </span>
                      </div>
                    </div>
                    <div className="trim-after-container d-none">
                      <div className="trim-after-time-element">
                        <div className="arrow left-arrow"></div>
                        <span className="trim-after-time">
                          {gifDuration.end}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="gifnote p-2 my-2">
                    <ImReply />
                    <h3 className="mt-4 px-3 text-info">
                      Select time frame to create GIF Above
                    </h3>
                    {gifPreview && (
                      <button className="btn py-2" onClick={handlePreviewGif}>
                        Preview GIF
                      </button>
                    )}
                  </div>
                  <div className="action-container mt-4">
                    <button
                      className="btn bg-secondary py-2"
                      onClick={(e) => handleShowGif("hide")}
                    >
                      Cancel Editing
                    </button>
                    <button className="btn py-2" onClick={handleGifVideoData}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </main>
    </>
  );
};

export default Pesonalize;
